import gql from 'graphql-tag';

const albumCustomPrintDetails = gql`
  fragment albumCustomPrintDetails on AlbumCustomPrint {
    id
    photos_no
    display_order
    custom_print {
      id
      name
      type
      subtype
      photos_no
      preview_image {
        id
        url
      }
      description
      custom_print_caption_enabled
      requires_package_purchase
      card {
        id
        card_side_groups {
          records {
            id
            side
            card_sides {
              records {
                id
                card_template {
                  id
                  orientation
                  print_product {
                    id
                    print_size {
                      id
                    }
                    print_partner {
                      id
                      name
                    }
                    sizes(slice: { limit: 999 }) {
                      records {
                        id
                        sku
                        print_size {
                          id
                          name
                        }
                      }
                    }
                  }
                  print_size {
                    id
                    name
                    width
                    height
                  }
                }
              }
            }
          }
        }
      }
      jersey_colors(slice: { limit: 999 }) {
        records {
          id
          jersey_color
        }
      }
    }
    price {
      value
      currency
    }
    discount_price {
      value
      currency
    }
    shipping_price {
      value
      currency
    }
    album {
      id
    }
    shipping_enabled
    shipping_required
  }
`;

export default albumCustomPrintDetails;
